import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = { class: "col-sm-12 d-flex align-items-center justify-content-center" }
const _hoisted_6 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_7 = { class: "col-sm-12 text-center" }
const _hoisted_8 = { class: "col-sm-12 wallet-address p-3 mt-1" }
const _hoisted_9 = { class: "d-flex flex-row gap-2 justify-content-center" }
const _hoisted_10 = {
  class: "m-0",
  style: {"font-size":"100%"}
}
const _hoisted_11 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-items-center font-monospace mt-2"
}
const _hoisted_12 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.deposit'),
    modelValue: _ctx.account !== null,
    "header-class": "text-capitalize",
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.account = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        class: "h-100"
      }, {
        default: _withCtx(() => [
          (_ctx.account)
            ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_AccountWidget, {
                          "hide-insurance": _ctx.store.getters.isMerchant,
                          "show-icon": "",
                          account: _ctx.account
                        }, null, 8, ["hide-insurance", "account"])
                      ])
                    ]),
                    (_ctx.wallet)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.address.usdt")), 1),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("pre", _hoisted_10, [
                                _createElementVNode("code", null, _toDisplayString(_ctx.wallet.address), 1)
                              ]),
                              _cache[4] || (_cache[4] = _createTextVNode()),
                              _createVNode(_component_copy_button, {
                                value: _ctx.wallet.address
                              }, null, 8, ["value"])
                            ]),
                            (_ctx.isAdmin || _ctx.isOperator)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("small", null, "TRX: " + _toDisplayString(_ctx.walletsInfo ? _ctx.numberFormatter.formatNumber(_ctx.walletsInfo?.trx) : 'n/a'), 1),
                                  _createElementVNode("small", null, "USDT: " + _toDisplayString(_ctx.walletsInfo ? _ctx.numberFormatter.formatNumber(_ctx.walletsInfo?.usdt) : 'n/a'), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_ctx.wallet === false && _ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.createWallet()), ["prevent"])),
                              type: "button",
                              class: "btn btn-outline-dark btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.create')), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      (_ctx.wallet && _ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.recreateWallet())),
            class: "btn btn-outline-dark btn-sm text-capitalize-first me-2"
          }, _toDisplayString(_ctx.helper.trans('button.recreate')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.account = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}